import * as React from 'react';
import * as _ from 'lodash';
import { cleanProps } from '../../../utilities/props';
import { MessageBox } from '../../../components/PageLayout/Popups/MessageBox';
import { SprocketButton } from '../../../components/Generic/sprocketButton';
import { PARTS } from './../../../schemas/accessRightsModel';
import SvgIcons from '../../../components/Icons/SvgIcons';
export default function () {
    function onComponentClick1(props, AR) {
        AR.v(PARTS.ASSIGN_PP_MANAGE) && this.props.showPricingPresetList();
    }
    function onClick2(props, AR) {
        this.showCloneIntoDialog();
    }
    function onClick3(props, AR) {
        {
            this.onSave(this.props.state);
        }
    }
    function onClick4(props, AR) {
        {
            this.setState({ showCancelMessage: true });
        }
    }
    function scopePropsAR5() {
        var props = this.props;
        var AR = this.props.AR;
        return React.createElement('div', _.assign({}, cleanProps(this.props)), React.createElement(MessageBox, {
            'visible': this.state.showCancelMessage,
            'title': 'Are you sure?',
            'message': 'WARNING! Canceling will clear all unsaved changes. Are you sure you want to do this?',
            'buttons': this.getCancelButtons()
        }), AR.v(PARTS.ASSIGN_PP_MANAGE) ? React.createElement(SprocketButton, {
            'onComponentClick': onComponentClick1.bind(this, props, AR),
            'text': 'Manage Pricing Profile',
            'key': '826'
        }) : null, AR.isSiteAdmin(true) ? React.createElement('div', {
            'style': {
                marginTop: '20px',
                marginLeft: '20px'
            },
            'key': '1013'
        }, React.createElement('button', {
            'className': 'ui-button--add ui-button5 ui-button5--gray ui-button5--select-all',
            'onClick': onClick2.bind(this, props, AR)
        }, React.createElement('div', { 'className': 'ui-button-icon' }, '\r\n        ', SvgIcons.cloneIcon, '\r\n      '), '\r\n      Clone Pricing Presets Into\r\n  ')) : null, React.createElement('div', { 'className': 'lightbox-button-block' }, props.updateItemCount > 0 ? React.createElement('div', {
            'className': 'lightbox-save-button',
            'onClick': onClick3.bind(this, props, AR),
            'key': '1399'
        }, 'Save ', props.updateItemCount > 0 ? React.createElement('span', {
            'className': 'updateCount',
            'title': 'Unsaved item count',
            'key': '1523'
        }, props.updateItemCount) : null) : null, props.updateItemCount > 0 ? React.createElement('div', {
            'className': 'lightbox-cancel-button',
            'onClick': onClick4.bind(this, props, AR),
            'key': '1652'
        }, 'Cancel') : null));
    }
    return scopePropsAR5.apply(this, []);
}